<template>
  <v-card>
    <v-card-text>
      <v-combobox v-model="streetsSelected" :items="streets" chips deletable-chips multiple
                  label="Selecteer straat"></v-combobox>
      <address-list-pageable :addresses="filterAddresses(streetsSelected)" enable-browser-back show-postcode></address-list-pageable>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn @click="back">Ga terug</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {service} from "@/services/address";
import AddressListPageable from "@/components/AddressListPageable";

export default {
  name: "WorklistPlannerAddresses",
  data: () => ({
    assignmentIds: [],
    addresses: [],
    streets: [],
    streetsSelected: [],
  }),
  components: {
    AddressListPageable,
  },
  methods: {
    populateAddressList(ids) {
      service.loadAddressesByAssignmentIds(ids)
          .then(result => {
            this.addresses = result.data;
            this.addresses.map(a => this.streets.push(a.address.street));
          });
    },
    back() {
      window.history.back();
    },
    filterAddresses(streetsToSelect) {
      return this.addresses.filter(item => {
        let addressItem = item.address.street.toUpperCase();
        if (streetsToSelect.length === 0) {
          return true;
        }
        return streetsToSelect.filter(e => addressItem.startsWith(e.toUpperCase())).length > 0;
      })
    }
  },
  created() {
    this.assignmentIds = this.$route.params.assignmentIds;
    this.populateAddressList(this.assignmentIds);
  }
}
</script>
